/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'Shared/components/Checkbox';
import { connect } from 'react-redux';
import RecommendationButton from 'Shared/components/RecommendationButton';


class Recommendation extends Component {
  render() {
    const {
      app,
      openProfile,
      openAccountModal,
      callExternalAPI,
      clickedCheckbox,
      clickedDismiss,
      clickedLink,
      recommendation,
      hideToggle,
      recommendation: {
        title,
        person,
        account,
        description,
        action_link,
        action_text,
        type,
        completed_at,
        dismissed_at,
        read_on_dashboard_at,
        buttons,
      },
    } = this.props;

    return (
      <React.Fragment>
        <div
          className="d-flex justify-content-start border-bottom py-3"
          style={!read_on_dashboard_at ? { backgroundColor: '#F3F7FF' } : {}}
        >
          {!hideToggle && <Checkbox toggle={clickedCheckbox} checked={!!completed_at} />}

          {app.id === 'web' && (
            <div
              className={`d-flex flex-grow-1 ml-2 justify-content-between ${completed_at ? 'text-super-muted' : ''}`}
            >
              <div>
                <div style={{ color: '#000' }}>
                  {title}
                  {person && !completed_at && (
                    <a
                      href="javascript:void(0);"
                      className="btn btn-outline-secondary btn-sm align-self-center ml-2"
                      onClick={() => openProfile(person)}
                    >
                      View Profile
                    </a>
                  )}
                  {account && !completed_at && (
                    <a
                      href="javascript:void(0);"
                      className="btn btn-outline-secondary btn-sm align-self-center ml-2"
                      onClick={() => openAccountModal(account)}
                    >
                      View Account
                    </a>
                  )}
                </div>
                <div className="text-muted">{description}</div>
              </div>

              <div className="d-flex align-items-center">
                {!completed_at && action_link && action_text && (
                  <a
                    target="_blank"
                    onClick={() => clickedLink('action_link', action_link)}
                    href={action_link}
                    className="btn btn-secondary align-self-center"
                    rel="noopener noreferrer"
                  >
                    {action_text}
                  </a>
                )}

                {buttons &&
                  buttons.map(button => (
                    <RecommendationButton
                      key={button.key}
                      button={button}
                      recommendation={recommendation}
                      clickedLink={clickedLink}
                      callExternalAPI={callExternalAPI}
                    />
                  ))}

                <div>
                  {!completed_at && (
                    <a
                      className="close ml-3 small text-muted mr-2"
                      style={{ cursor: 'pointer' }}
                      onClick={clickedDismiss}
                    >
                      <WpIcon name="times" />
                    </a>
                  )}
                </div>
              </div>
            </div>
          )}

          {app.id === 'chrome' && (
            <div className={`${completed_at ? 'text-super-muted' : ''}`}>
              <div className="d-flex justify-content-between">
                <div>
                  <h5>
                    {title}
                    {person && !completed_at && (
                      <a
                        href="javascript:void(0);"
                        className="btn btn-outline-secondary btn-sm align-self-center ml-2"
                        onClick={() => openProfile(person)}
                      >
                        View Profile
                      </a>
                    )}
                    {account && !completed_at && (
                      <a
                        href="javascript:void(0);"
                        className="btn btn-outline-secondary btn-sm align-self-center ml-2"
                        onClick={() => openAccountModal(account)}
                      >
                        View Account
                      </a>
                    )}
                  </h5>
                  <small>{description}</small>
                </div>

                <div className="alert-dismissible">
                  {!completed_at && (
                    <a className="close" style={{ cursor: 'pointer' }} onClick={clickedDismiss}>
                      &times;
                    </a>
                  )}
                </div>
              </div>

              <div className={`d-flex mt-2 justify-content-between ${completed_at ? 'text-super-muted' : ''}`}>
                {!completed_at && action_link && action_text && (
                  <a target="_blank" href={action_link} className="btn btn-secondary align-self-center" rel="noopener noreferrer">
                    {action_text}
                  </a>
                )}

                {buttons &&
                  buttons.map(button => (
                    <RecommendationButton
                      key={button.key}
                      button={button}
                      recommendation={recommendation}
                      clickedLink={clickedLink}
                      callExternalAPI={callExternalAPI}
                    />
                  ))}
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

Recommendation.propTypes = {
  recommendation: PropTypes.object.isRequired,
  clickedCheckbox: PropTypes.func.isRequired,
  clickedDismiss: PropTypes.func.isRequired,
  clickedLink: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  app: state.app,
});

export default connect(mapStateToProps)(Recommendation);
